if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.boundKeyHandler = this.onKeyDown.bind(this);
        this.initNavigation();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.updateNavigationState();
        document.addEventListener('keydown', this.boundKeyHandler);
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      initNavigation() {
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.contentContainer = this.querySelector('.product-media-modal__content');

        if (this.prevButton) {
          this.prevButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showPreviousMedia();
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showNextMedia();
          });
        }
      }

      onKeyDown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPreviousMedia();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNextMedia();
        }
      }

      updateNavigationState() {
        const mediaItems = this.getMediaItems();
        const hasMultiple = mediaItems.length > 1;

        if (this.prevButton) {
          this.prevButton.style.display = hasMultiple ? 'flex' : 'none';
        }

        if (this.nextButton) {
          this.nextButton.style.display = hasMultiple ? 'flex' : 'none';
        }
      }

      showMediaByIndex(index) {
        const mediaItems = this.getMediaItems();
        if (!mediaItems.length) return;

        if (index < 0) index = mediaItems.length - 1;
        if (index >= mediaItems.length) index = 0;

        const targetMedia = mediaItems[index];
        if (!targetMedia) return;

        mediaItems.forEach((element) => {
          element.classList.remove('active');
        });

        const activeMediaTemplate = targetMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        targetMedia.classList.add('active');
        targetMedia.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });

        const container = this.contentContainer || this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft =
            targetMedia.offsetLeft - (container.clientWidth - targetMedia.clientWidth) / 2;
        }

        if (
          targetMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          targetMedia.loadContent();
        }

        this.currentIndex = index;
      }

      showPreviousMedia() {
        this.showMediaByIndex(this.currentIndex - 1);
      }

      showNextMedia() {
        this.showMediaByIndex(this.currentIndex + 1);
      }

      showActiveMedia() {
        const mediaItems = this.getMediaItems();
        const openedMediaId = this.openedBy.getAttribute('data-media-id');

        mediaItems.forEach((element, index) => {
          if (element.getAttribute('data-media-id') === openedMediaId) {
            this.currentIndex = index;
          }
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${openedMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });

        const container = this.contentContainer || this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft =
            activeMedia.offsetLeft - (container.clientWidth - activeMedia.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}